if (typeof ProductMobilePurchaseBar !== 'function') {

  const MOBILE_MQ = window.matchMedia('(max-width: 727px)');

  function clearStuckPurchaseButtonWorkingState() {
    document
      .querySelectorAll(
        '.product-mobile-purchase-bar__btn.working, #quick-product-drawer-host .variant-drawer__btn.working'
      )
      .forEach((btn) => {
        btn.classList.remove('working');
      });
  }

  function restoreVariantSelectionStateAfterBfcache() {
    document.querySelectorAll('product-variants[data-variant-required]').forEach((el) => {
      if (typeof el.updateOptions === 'function') {
        el.updateOptions();
      }
      if (typeof el.updateMasterId === 'function') {
        el.updateMasterId();
      }
      if (typeof el._syncVariantSelectedClass === 'function') {
        el._syncVariantSelectedClass();
      } else if (el.currentVariant) {
        el.noVariantSelectedYet = false;
        el.classList.add('variant-selected');
      }
    });
  }

  function restorePurchaseUiAfterBfcache() {
    clearStuckPurchaseButtonWorkingState();
    document.body.classList.remove('variant-drawer-open');
    restoreVariantSelectionStateAfterBfcache();
    if (
      typeof VariantDrawer === 'function' &&
      VariantDrawer._instance &&
      typeof VariantDrawer._instance._refreshDomReferences === 'function'
    ) {
      VariantDrawer._instance._refreshDomReferences();
      VariantDrawer._instance._markMainVariantSelected();
      VariantDrawer._instance._updateDrawerUi();
    }
    document.querySelectorAll('product-mobile-purchase-bar').forEach((bar) => {
      if (typeof bar._refreshDomReferences === 'function') {
        bar._refreshDomReferences();
      }
      bar._ensureMainVariantSelected?.();
      bar.updateState?.();
    });
  }

  if (!window.__krownPurchaseBarPageshowBound) {
    window.__krownPurchaseBarPageshowBound = true;
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) {
        return;
      }
      restorePurchaseUiAfterBfcache();
    });
  }

  class ProductMobilePurchaseBar extends HTMLElement {

    constructor() {
      super();
      this._mqListener = () => this._onMqChange();
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.productPage = document.getElementById(this.dataset.productPageId);
      if (!this.productPage) {
        return;
      }

      this.singleVariant = this.hasAttribute('data-single-variant');
      this.atcBtn = this.querySelector('[data-js-mobile-atc]');
      this.atcText = this.querySelector('[data-js-mobile-atc-text]');
      this.buyNowBtn = this.querySelector('[data-js-mobile-buy-now]');
      this.buyNowText = this.querySelector('[data-js-mobile-buy-now-text]');

      this.mainVariants = this.productPage.querySelector('.product-text product-variants');
      this.mainFormHost = this.productPage.querySelector('product-form');
      this.mainForm = this.mainFormHost && this.mainFormHost.querySelector('form');
      this.drawer = document.querySelector(`variant-drawer[data-section-id="${this.sectionId}"]`);
      this.drawerFormHost = this.drawer && this.drawer.querySelector('product-form');
      this.drawerForm = this.drawerFormHost && this.drawerFormHost.querySelector('form');

      this.atcBtn?.addEventListener('click', () => this._onAtcClick());
      this.buyNowBtn?.addEventListener('click', () => this._onBuyNowClick());

      MOBILE_MQ.addEventListener('change', this._mqListener);
      this._onMqChange();
      if (MOBILE_MQ.matches) {
        requestAnimationFrame(() => this._syncBarHeightVar());
      }
      this.updateState();

      if (this.mainVariants) {
        this.mainVariants.addEventListener('VARIANT_CHANGE', () => this.updateState());
      }
      if (this.drawer) {
        this.drawer.addEventListener('VARIANT_CHANGE', () => this.updateState());
        const drawerVariants = this.drawer.querySelector('.variant-drawer__body product-variants');
        drawerVariants?.addEventListener('VARIANT_CHANGE', () => this.updateState());
        drawerVariants?.addEventListener('change', () => this.updateState());
      }
    }

    disconnectedCallback() {
      MOBILE_MQ.removeEventListener('change', this._mqListener);
    }

    _syncBarHeightVar() {
      document.documentElement.style.setProperty(
        '--mobile-purchase-bar-height',
        `${this.offsetHeight}px`
      );
    }

    _onMqChange() {
      if (MOBILE_MQ.matches) {
        this.hidden = false;
        this.setAttribute('aria-hidden', 'false');
        this._syncBarHeightVar();
      } else {
        this.hidden = true;
        this.setAttribute('aria-hidden', 'true');
      }
      this.updateState();
    }

    _refreshDomReferences() {
      if (this.dataset.productPageId) {
        this.productPage = document.getElementById(this.dataset.productPageId);
      }
      if (this.productPage) {
        this.mainVariants = this.productPage.querySelector('.product-text product-variants');
        this.mainFormHost = this.productPage.querySelector('product-form');
        this.mainForm = this.mainFormHost && this.mainFormHost.querySelector('form');
      }
      this.drawer = document.querySelector(`variant-drawer[data-section-id="${this.sectionId}"]`);
      this.drawerFormHost = this.drawer && this.drawer.querySelector('product-form');
      this.drawerForm = this.drawerFormHost && this.drawerFormHost.querySelector('form');
    }

    _ensureMainVariantSelected() {
      const variant = this._getActiveVariant();
      if (
        !variant ||
        !this.mainVariants ||
        !this.mainVariants.hasAttribute('data-variant-required')
      ) {
        return;
      }
      this.mainVariants.classList.add('variant-selected');
      this.mainVariants.noVariantSelectedYet = false;
    }

    _needsVariantSelection() {
      if (this.singleVariant) {
        return false;
      }
      this._refreshDomReferences();
      if (this._getActiveVariant()) {
        return false;
      }
      return (
        this.mainVariants &&
        this.mainVariants.hasAttribute('data-variant-required') &&
        !this.mainVariants.classList.contains('variant-selected')
      );
    }

    _getActiveVariant() {
      this._refreshDomReferences();
      const drawerVariants = this.drawer && this.drawer.querySelector('.variant-drawer__body product-variants');
      if (drawerVariants && drawerVariants.currentVariant) {
        return drawerVariants.currentVariant;
      }
      if (this.mainVariants && this.mainVariants.currentVariant) {
        return this.mainVariants.currentVariant;
      }
      if (this.singleVariant && this.mainVariants && typeof this.mainVariants.getVariantData === 'function') {
        const variants = this.mainVariants.getVariantData();
        if (variants?.length) {
          return variants.find((item) => item.available) || variants[0];
        }
      }
      return null;
    }

    _getPurchaseForm() {
      const drawerVariants = this.drawer && this.drawer.querySelector('.variant-drawer__body product-variants');
      if (drawerVariants && drawerVariants.currentVariant && this.drawerForm) {
        return this.drawerForm;
      }
      return this.mainForm || this.drawerForm;
    }

    _syncFormVariantId() {
      const variant = this._getActiveVariant();
      if (!variant) {
        return;
      }
      [this.mainForm, this.drawerForm].forEach((form) => {
        if (!form) {
          return;
        }
        let idInput = form.querySelector('input[name="id"]');
        if (!idInput) {
          idInput = document.createElement('input');
          idInput.type = 'hidden';
          idInput.name = 'id';
          form.prepend(idInput);
        }
        idInput.value = variant.id;
      });
    }

    updateState() {
      if (!MOBILE_MQ.matches) {
        return;
      }

      this._ensureMainVariantSelected();
      const variant = this._getActiveVariant();
      const needsSelection = this._needsVariantSelection();
      const hasVariant = Boolean(variant) || this.singleVariant;
      const canPurchase = hasVariant && (!variant || variant.available);

      this._syncFormVariantId();

      [this.atcBtn, this.buyNowBtn].forEach((btn) => {
        if (!btn) {
          return;
        }
        btn.classList.remove('disabled', 'needs-variant', 'sold-out');
        if (needsSelection) {
          btn.classList.add('needs-variant');
          btn.disabled = false;
        } else if (!canPurchase) {
          btn.classList.add('sold-out');
          btn.disabled = true;
        } else {
          btn.disabled = false;
        }
      });

      if (this.atcText) {
        if (variant && !variant.available) {
          this.atcText.textContent = KROWN.settings.locales.products_sold_out_variant;
        } else {
          this.atcText.textContent = KROWN.settings.locales.products_add_to_cart_button;
        }
      }

      if (this.buyNowText) {
        this.buyNowText.textContent = KROWN.settings.locales.products_variant_drawer_buy_now;
      }
    }

    openDrawerIfNeeded() {
      if (!this._needsVariantSelection()) {
        return false;
      }
      if (this.drawer && typeof this.drawer.open === 'function') {
        return this.drawer.open();
      }
      return false;
    }

    _clearWorkingState() {
      this.atcBtn?.classList.remove('working');
      this.buyNowBtn?.classList.remove('working');
    }

    _navigateAway(url) {
      this._clearWorkingState();
      window.location.href = url;
    }

    async _onAtcClick() {
      if (!MOBILE_MQ.matches) {
        return;
      }
      this._refreshDomReferences();
      this._ensureMainVariantSelected();
      if (this.openDrawerIfNeeded()) {
        return;
      }

      const variant = this._getActiveVariant();
      if (!variant) {
        if (this._needsVariantSelection()) {
          this.openDrawerIfNeeded();
        }
        return;
      }
      if (!variant.available) {
        return;
      }

      const form = this._getPurchaseForm();
      if (!form) {
        return;
      }

      this._syncFormVariantId();
      this.atcBtn?.classList.add('working');

      try {
        const response = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: this._serializeForm(form),
        });
        const data = await response.json();
        if (data.status === 422) {
          return;
        }

        this.drawer?.close?.();

        const cartAction = window.KROWN?.settings?.cart_action;
        const cartUrl = window.KROWN?.settings?.routes?.cart_url || '/cart';

        if (cartAction === 'overlay' && document.getElementById('site-cart-sidebar')) {
          this._clearWorkingState();
          const text = await fetch('?section_id=helper-cart').then((res) => res.text());
          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
          const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm')?.innerHTML;
          const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal')?.innerHTML;

          if (cartFormInnerHTML && document.getElementById('AjaxCartForm')) {
            const cartItems = document.getElementById('AjaxCartForm');
            cartItems.innerHTML = cartFormInnerHTML;
            if (typeof cartItems.ajaxifyCartItems === 'function') {
              cartItems.ajaxifyCartItems();
            }
          }

          if (cartSubtotalInnerHTML && document.getElementById('AjaxCartSubtotal')) {
            document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
          }

          document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
            const countEl = document.querySelector('#AjaxCartForm [data-cart-count]');
            if (countEl) {
              elm.textContent = countEl.textContent;
            }
          });
          document.querySelectorAll('[data-header-cart-total]').forEach((elm) => {
            const totalEl = document.querySelector('#AjaxCartForm [data-cart-total]');
            if (totalEl) {
              elm.textContent = totalEl.textContent;
            }
          });

          if (typeof window.opusOpen === "function") {
						window.opusOpen();
						return;
					}

          document.getElementById('site-cart-sidebar')?.show?.();
        } else {
          this._navigateAway(cartUrl);
          return;
        }
      } catch (e) {
        console.log(e);
      } finally {
        this._clearWorkingState();
      }
    }

    async _onBuyNowClick() {
      if (!MOBILE_MQ.matches) {
        return;
      }
      this._refreshDomReferences();
      this._ensureMainVariantSelected();
      if (this.openDrawerIfNeeded()) {
        return;
      }

      const variant = this._getActiveVariant();
      if (!variant) {
        if (this._needsVariantSelection()) {
          this.openDrawerIfNeeded();
        }
        return;
      }
      if (!variant.available) {
        return;
      }

      const form = this._getPurchaseForm();
      if (!form) {
        return;
      }

      this._syncFormVariantId();
      this.buyNowBtn?.classList.add('working');

      try {
        const response = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: this._serializeForm(form),
        });
        const data = await response.json();
        if (data.status === 422) {
          return;
        }

        this.drawer?.close?.();
        this._navigateAway('/checkout');
        return;
      } catch (e) {
        console.log(e);
      } finally {
        this._clearWorkingState();
      }
    }

    _serializeForm(form) {
      const arr = [];
      Array.prototype.slice.call(form.elements).forEach((field) => {
        if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) {
          return;
        }
        if (field.type === 'checkbox' || field.type === 'radio') {
          if (!field.checked) {
            return;
          }
        }
        arr.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
      });
      return arr.join('&');
    }
  }

  if (typeof customElements.get('product-mobile-purchase-bar') === 'undefined') {
    customElements.define('product-mobile-purchase-bar', ProductMobilePurchaseBar);
  }
}
